import { requesterUpdatesFilter } from './filters/requesterUpdates.filter';
import ApiService from './api.service';

class RequesterUpdatesService {
  static async getRequesterUpdatesForRequest(requestId) {
    const filter = requesterUpdatesFilter(requestId);
    const url = `${window.ambulnzConfig.tenantedRestApiUrl}/RequesterUpdates?filter=${JSON.stringify(filter)}`;
    let response = await ApiService.get(url);
    response = response.json();
    return response;
  }
}

export default RequesterUpdatesService;
